<template>
  <v-container fluid>
    <v-card :loading="loading">
      <v-card-title>
        <h2>
          <v-btn class="mr-2" icon :to="{ name: 'permissoes-list' }">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="loading">Carregando...</span>
          <template v-else>
            <span v-if="form.id === ''">Nova permissão de acesso</span>
            <span v-else>Alterar permissão de acesso: {{form.nome}}</span>
          </template>
        </h2>
      </v-card-title>
      <form @submit.prevent="submitForm">
        <v-card-text>
          <v-text-field
            v-model="$v.form.nome.$model"
            v-touch="form.nome"
            :error-messages="nomeErrors"
            :counter="40"
            label="Nome"
          ></v-text-field>
          <v-text-field
            v-model="form.descricao"
            v-touch="form.descricao"
            :counter="140"
            label="Descrição"
          ></v-text-field>
          <v-text-field
            v-model="form.grupo"
            v-touch="form.grupo"
            :error-messages="grupoErrors"
            :counter="40"
            label="Grupo"
            hint="Identificador para agrupar permissões durante atribuição"
            persistent-hint
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import _ from "lodash";

const padrao = {
  id: "",
  nome: "",
  descricao: "",
  grupo: ""
};
export default {
  data() {
    return {
      form: _.clone(padrao),
      loading: false
    };
  },
  validations: {
    form: {
      nome: { required, maxLength: maxLength(40) },
      descricao: { maxLength: maxLength(140) },
      grupo: { maxLength: maxLength(40) }
    }
  },
  computed: {
    nomeErrors() {
      const errors = [];
      if (!this.$v.form.nome.$dirty) return errors;
      !this.$v.form.nome.required &&
        errors.push("Informe o nome da permissão.");
      !this.$v.form.nome.maxLength && errors.push("Somente 40 caracteres.");
      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.form.descricao.$dirty) return errors;
      !this.$v.form.descricao.maxLength &&
        errors.push("Somente 140 caracteres.");
      return errors;
    },
    grupoErrors() {
      const errors = [];
      if (!this.$v.form.grupo.$dirty) return errors;
      !this.$v.form.grupo.maxLength && errors.push("Somente 40 caracteres.");
      return errors;
    }
  },
  async mounted() {
    this.loading = true;

    if (this.$route.params.id) {
      try {
        const response = await this.$store.dispatch(
          "permissao/carregarPermissao",
          this.$route.params.id
        );
        this.form = response.data;
      } catch (e) {
        console.log(e);
      }
    }

    this.loading = false;
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          await this.$store.dispatch("permissao/gravar", this.form);
          this.$router.replace({ name: "permissoes-list" });
        } catch (e) {
          console.log(e);
        }
        this.loading = false;
      }
    }
  }
};
</script>
